import { Component, ElementRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommunicationProxyService } from '../../../services/communication-proxy.service';
import { LoginService } from '../../../services/login.service';
import { StringTableService } from '../../../services/string-table.service';
import { PageViewComponent } from '../../page-view/page-view.component';
import { activeTrainingPageEnum, TrainingManagementComponent } from '../training-management/training-management.component';

@Component({
  selector: 'app-super-admin',
  templateUrl: './super-admin.component.html',
  styleUrls: ['./super-admin.component.scss']
})
export class SuperAdminComponent extends PageViewComponent implements OnInit {

  constructor(
    ele: ElementRef,
    remoteProxy: CommunicationProxyService,
    protected loginService: LoginService,
    stringTableService: StringTableService,
    protected router: Router
  ) {
    super(ele, remoteProxy, loginService, stringTableService, router);
  }

  ngOnInit() {
    TrainingManagementComponent.setActiveTrainingPage(activeTrainingPageEnum.superAdmin);
  }

  displayHome() {
    this.router.navigate(['/home']);
  }

}



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/training-management/super-admin/super-admin.component.ts